/* eslint-disable no-unused-vars */
/* eslint-disable react/no-unescaped-entities */
import React from 'react';
import { Card, Button, Row, Col, Form } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import Select from 'react-select';
import makeAnimated from 'react-select/animated';
import { toast } from 'react-hot-toast';
import { loaderActions } from '../../../../../features/Loader/LoaderSlice';
import API from '../../../../../Services/API';
import _ from 'lodash';
import { downloadPurchaseOrderLines } from '../../../../../Helpers/xlxs/download';
import { DELIVERY_COMPLETED_FILTER } from '../../../../../Helpers/purchaseOrderFilters';

function ExportWarehousePOs(props) {
  const animatedComponents = makeAnimated();

  const dispatch = useDispatch();
  const [separateFile, setSeparateFile] = React.useState(false);
  const [selectedVendors, setSelectedVendors] = React.useState([]);
  const [excludeComplete, setExcludeComplete] = React.useState(false);

  async function exportWarehousePOs() {
    await dispatch(loaderActions.show());

    const EmmaParams = {
      company_id: process.env.REACT_APP_COMP_EMM
    };

    const DunParams = {
      company_id: process.env.REACT_APP_COMP_DUN
    };
    let filter = '';
    let uniqueOrders = [];
    if (selectedVendors.length > 0) {
      const uniqueVendors = [...new Set(selectedVendors.map((v) => v.value))];
      await uniqueVendors.forEach((vendor, index) => {
        if (index === 0) {
          filter = `contains(whseVendorCode, '${vendor}')`;
        } else {
          filter = filter + ` or contains(whseVendorCode, '${vendor}')`;
        }
      });
      EmmaParams.$filter = filter;
      DunParams.$filter = filter;
    }
    if (excludeComplete) {
      let deliveryCompletedFilter = '';
      if (filter.length > 0) {
        deliveryCompletedFilter = `and ${DELIVERY_COMPLETED_FILTER}`;
      } else {
        deliveryCompletedFilter = DELIVERY_COMPLETED_FILTER;
      }
      const params = {
        company_id: process.env.REACT_APP_COMP_EMM,
        $filter: `${filter.length > 0 ? '(' + filter + ')' : ''} ${deliveryCompletedFilter}`.trim(),
        $select: `docNo`
      };
      const res = await API().get('/purchase_order_header', { params });
      uniqueOrders = [...new Set(res.data.value.map((line) => line.docNo))];
    }
    const EmmaRes = await API().get(`/purchase_order_lines`, { params: EmmaParams });
    const emmaPos = EmmaRes.data.value;
    const DunRes = await API().get(`/purchase_order_lines`, { params: DunParams });
    const dunPos = DunRes.data.value;
    let allPos = emmaPos.concat(dunPos || []);
    if (allPos === 0) {
      toast.error('No POs found for the selected vendors');
    } else {
      if (excludeComplete) {
        allPos = allPos.filter(
          (line) => line.typeOfDeliveryCompleted === false && uniqueOrders.includes(line.documentNo)
        );
      }
      if (separateFile) {
        const supplierPos = _.groupBy(allPos, 'vendorNo');
        const vendors = props.vendors;
        await _.forEach(supplierPos, async (supplier, key) => {
          const vendor = vendors.find((vend) => vend.vendNo === key);
          const vendorName = vendor ? vendor.vendName : key;
          await downloadPurchaseOrderLines(supplier, `Warehouse-${vendorName}-POs-Lines`);
        });
      } else {
        await downloadPurchaseOrderLines(allPos, `All-Warehouse-POs-Lines`);
      }
    }
    await dispatch(loaderActions.hide());
  }

  return (
    <>
      <Card className="p-4 ">
        <div className="text-center"></div>
        <Card.Body className="p-4">
          <Card.Title>
            <i className="feather icon-download mt-2" /> &nbsp; Export Warehouse PO's
          </Card.Title>
          <Card.Text>
            Export PO's from all warehouse to a CSV file. You can update the PO's accordingly and
            upload again to update.
          </Card.Text>
          <Row>
            <Col>
              <Form.Group controlId="vendors">
                <Form.Label>Vendors</Form.Label>
                <Select
                  components={animatedComponents}
                  options={props.vendors.map((v) => ({
                    value: v.vendNo,
                    label: v.vendName
                  }))}
                  value={selectedVendors}
                  isSearchable={true}
                  isMulti
                  onChange={(e) => {
                    setSelectedVendors(() => e);
                  }}
                />
                <Form.Text className="text-muted">Leave Empty for access to All Vendors</Form.Text>
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col>
              <Form.Group controlId="separateWHPOs">
                <Form.Check
                  type="checkbox"
                  label="Generate separate file for every vendor"
                  checked={separateFile}
                  onChange={(e) => setSeparateFile(() => e.target.checked)}
                />
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col>
              <Form.Group controlId="allOrdersWarehouse">
                <Form.Check
                  type="checkbox"
                  label="Exclude completed orders(Export similar to Vendor Dashboard)"
                  checked={excludeComplete}
                  onChange={(e) => setExcludeComplete(() => e.target.checked)}
                />
              </Form.Group>
            </Col>
          </Row>
          <Button variant="primary" onClick={exportWarehousePOs}>
            Export all warehouse lines
          </Button>
        </Card.Body>
      </Card>
    </>
  );
}

export default ExportWarehousePOs;
